import { createAction } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const fetchItemOfflineVerificationEligibility = createAction("".concat(stateName, "/fetchItemOfflineVerificationEligibility"));
export const requestItemAuthenticityModal = createAction("".concat(stateName, "/requestItemAuthenticityModal"), function () {
  let force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return {
    payload: {
      force
    }
  };
});
export const fetchBrands = createAction("".concat(stateName, "/fetchBrands"), _ref => {
  let {
    keyword = '',
    includeAllBrands = false
  } = _ref;
  return {
    payload: {
      keyword,
      includeAllBrands
    }
  };
});
export const fetchShippingOptionsRequest = createAction("".concat(stateName, "/fetchShippingOptionsRequest"));
export const fetchPriceSuggestions = createAction("".concat(stateName, "/fetchPriceSuggestions"));
export const fetchItemRequest = createAction("".concat(stateName, "/fetchItemRequest"));
export const fetchIsSecondDayListerRequest = createAction("".concat(stateName, "/fetchIsSecondDayListerRequest"));
export const fetchIsPreviousListerRequest = createAction("".concat(stateName, "/fetchIsPreviousListerRequest "));
export const fetchPhotoTips = createAction("".concat(stateName, "/fetchPhotoTips"));
export const submitItem = createAction("".concat(stateName, "/submitItem"), function (saveAsDraft) {
  let isItemPushedUp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    payload: {},
    meta: {
      saveAsDraft,
      isItemPushedUp
    }
  };
});
export const deleteDraft = createAction("".concat(stateName, "/deleteDraft"));
export const selectCatalog = createAction("".concat(stateName, "/selectCatalog"));
export const fetchCatalogs = createAction("".concat(stateName, "/fetchCatalogs"));
export const fetchSizesConfiguration = createAction("".concat(stateName, "/fetchSizesConfiguration"));
export const fetchStatuses = createAction("".concat(stateName, "/fetchStatuses"));
export const fetchSizeGroups = createAction("".concat(stateName, "/fetchSizeGroups"));
export const fetchVideoGameRatings = createAction("".concat(stateName, "/fetchVideoGameRatings"));
export const fetchPackageSizesRequest = createAction("".concat(stateName, "/fetchPackageSizesRequest"));
export const getDropOffLocationPrompt = createAction("".concat(stateName, "/getDropOffLocationPrompt"));